<template>
  <card class="card" :title="title">
    <div>
      <ul class="list-unstyled team-members">
        <li>
          <div class="row" v-for="member in members" :key="member.name">
            <div class="col-3">
              <div class="avatar">
                <img
                  :src="member.image"
                  alt="Circle Image"
                  class="rounded img-fluid"
                />
              </div>
            </div>
            <div class="col-6">
              {{ member.name }}
              <br />
              <span :class="getStatusClass(member.status)">
                <small>{{ member.status }}</small>
              </span>
            </div>

            <div class="col-3">
              <p-button type="success" outline icon>
                <i class="fa fa-envelope"></i>
              </p-button>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </card>
</template>
<script>
export default {
  data() {
    return {
      title: '',
      members: [],
    };
  },
  methods: {
    getStatusClass(status) {
      switch (status) {
        case "Offline":
          return "text-muted";
        case "Available":
          return "text-success";
        case "Busy":
          return "text-danger";
        default:
          return "text-success";
      }
    },
  },
};
</script>
<style scoped>
.team-members {
  padding: 0;
  margin: 0;
}
.team-members li {
  margin-bottom: 1.2rem;
}
.avatar img {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 50%;
}
.row {
  display: flex;
  align-items: center;
  margin: 0;
}
.col-3, .col-6 {
  padding: 0 6px;
}
.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}
.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}
@media (max-width: 768px) {
  .avatar img {
    width: 38px;
    height: 38px;
  }
  .col-3, .col-6 {
    padding: 0 2px;
  }
}
@media (max-width: 576px) {
  .row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  .col-3, .col-6 {
    max-width: 100%;
    flex: 1 1 100%;
    padding: 0;
  }
  .avatar img {
    width: 32px;
    height: 32px;
  }
  .p-button {
    width: 100%;
    margin-top: 0.5rem;
  }
}
</style>
